import { createSlice, PayloadAction } from "@reduxjs/toolkit";

// Auth
import { userLogin, userLogout } from "./actions";
import Pa from "src/models/pa";

import { PauseType } from "src/types";
import { DTLayer } from "src/services/data-layer";
import { faro } from "src/services/logger";

type AuthState = {
  accessToken: string | null;
  loading: boolean;
  userInfo: Pa;
  isLoggedIn: boolean;
  error: string | null;
  manualLogout: boolean;
  paused: null | PauseType;
  scheduledPause: PauseType | null;
  appWasLoaded: boolean;
};

const initialState: AuthState = {
  accessToken: null,
  userInfo: new Pa({}),
  loading: false,
  isLoggedIn: false,
  error: null,
  manualLogout: false,
  appWasLoaded: false,

  // Pause State
  paused: null,
  scheduledPause: null,
};

const authlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAppAsLoaded: (state) => {
      state.appWasLoaded = true;
    },
    paDetailsLoaded: (state, { payload }) => {
      state.userInfo = new Pa({ ...state.userInfo, ...payload });

      // Push layer
      DTLayer.dispatch("loadPaInfo", {
        userData: {
          id: state.userInfo.id,
          name: state.userInfo.name,
          email: state.userInfo.email,
        },
      });

      faro.api.setUser({
        email: state.userInfo.email,
        fullName: state.userInfo.name,
        id: state.userInfo.id,
      });
    },

    setScheduledPause: (state, { payload }) => {
      state.scheduledPause = payload;
    },

    requestPause: (state, { payload }) => {
      state.paused = payload;
    },

    requestUnpause: (state) => {
      state.paused = null;
    },

    invalidToken: (state, action: PayloadAction<boolean | undefined>) => ({
      ...initialState,
      appWasLoaded: false,
      manualLogout: action?.payload || false,
    }),
  },
  extraReducers: (builder) => {
    builder.addCase(userLogin.pending, (state) => {
      state.loading = true;
    });

    builder.addCase(userLogin.fulfilled, (state, { payload }) => {
      const accessToken = `${payload.token_type} ${payload.access_token}`;

      state.loading = false;
      state.accessToken = accessToken;
      state.isLoggedIn = true;
      state.userInfo.email = payload.email;
      state.manualLogout = false;
      state.error = null;

      try {
        window.chrome.runtime.sendMessage(import.meta.env.VITE_APP_EXTENSION_ID, {
          type: "SF/SET_TOKEN",
          payload: {
            token: accessToken,
          },
        });
      } catch (ex) {}
    });

    builder.addCase(userLogin.rejected, (state, { payload }) => {
      state.loading = false;
      state.error = typeof payload === "string" ? payload : "Erro ao logar no sistema.";
    });

    builder.addCase(userLogout.fulfilled, (state, { payload }) => ({
      ...initialState,
      appWasLoaded: false,
      manualLogout: payload.manualLogout, //|| false,
    }));
  },
});

export const {
  paDetailsLoaded,
  // logout,
  invalidToken,
  requestPause,
  requestUnpause,
  setScheduledPause,
  setAppAsLoaded,
} = authlice.actions;
export default authlice.reducer;
